import { useTranslation } from 'react-i18next'

import useApiCall from '../../api/useApiCall'
import { getUsers } from '../../api/users'
import { useUsersStore } from '../../stores/usersStore'
import LoadingSection from '../LoadingSection/LoadingSection'

import AddUser from './AddUser/AddUser'
import User from './User/User'

import styles from './users.module.scss'

function Users() {
    const { t } = useTranslation()

    const [{ users }, { setUsers }] = useUsersStore()

    const [{ loading }] = useApiCall(getUsers, setUsers)

    if (loading) {
        return (
            <section className={styles.users}>
                <LoadingSection />
            </section>
        )
    }

    return (
        <section className={styles.users}>
            <AddUser />
            <div className={styles.users__headWrapper}>
                <div className={styles.users__head}>
                    <div className={styles.users__headText}>{t('name')}</div>
                    <div className={styles.users__headText}>{t('email')}</div>
                    <div className={styles.users__headText}>{t('role')}</div>
                </div>
            </div>
            <div className={styles.users__users}>
                {users.map((user) => (
                    <User
                        key={user._id}
                        id={user._id}
                        name={user.username}
                        email={user.email}
                        role={user.role}
                    />
                ))}
            </div>
        </section>
    )
}

export default Users
